import {
  Button,
  Copy,
  Heading,
  SvgCircleX,
} from '@grubhubprod/gh-cookbook-react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { ZipFileFilters } from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { FilterInformation } from './FilterInformation';

interface DownloadFailedModalProps {
  filters: ZipFileFilters;
  onClose: () => void;
}

export function DownloadFailedModal({
  filters,
  onClose,
}: DownloadFailedModalProps): JSX.Element {
  return (
    <Modal size="xs">
      <Square inset="md">
        <Stack y="sm">
          <Heading variant="h1">Download failed</Heading>
        </Stack>
        <Stack
          aria-label="Error"
          y="sm"
          color="danger"
          display="flex"
          alignItems="center"
        >
          <Copy variant="body" color="danger">
            <Stack x="sm" height="100%">
              <SvgCircleX size="20px" color="secondaryText" />
            </Stack>
          </Copy>
          There was a problem downloading your receipts. Please try again.
        </Stack>
        <Stack aria-label="Filters">Receipts for orders:</Stack>
        <Stack as="ul" y="md">
          <FilterInformation filters={filters} />
        </Stack>
        <Stack width="100%">
          <Button
            block
            variant="secondary"
            buttonSize="medium"
            onClick={onClose}
          >
            Try again
          </Button>
        </Stack>
      </Square>
    </Modal>
  );
}
